//*
import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import WhatshotIcon from "@mui/icons-material/Whatshot";
//
import { Link as RLink, useParams } from "react-router-dom";
//
import { useGetContactQuery } from "../../api/contact";
import styles from "./User.module.css";

export default function Contact() {
    let { id } = useParams();
    const { data, isFetching, isError } = useGetContactQuery(id, {
        skip: false,
    });

    return (
        <Box>
            {isFetching && <>IsFetching</>}
            {isError && <>IsError</>}
            {data && (
                <Card sx={{ minWidth: 275, maxWidth: 1200 }}>
                    <CardContent>
                        <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                            gutterBottom
                        >
                            test.secondary and gutterBottm
                        </Typography>
                        <Typography variant="h5" component="div">
                            {data.contact.first_name}
                        </Typography>
                        <Typography variant="body2">
                            {data.contact.content.content}
                            <br />
                            {data.contact.birthday}
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button size="small">Edit</Button>
                        <Button
                            component={RLink}
                            to={
                                "/file/by-filter?contact_id=" +
                                data.contact.metadata.id
                            }
                            size="small"
                        >
                            Files
                        </Button>
                    </CardActions>
                </Card>
            )}
        </Box>
    );
}
